import { useEffect, useRef, useState } from "react";
import AppIcon from "../AppIcon";
import './style.css';

interface IMenuProps {
  menuList: {
    label: string;
    icon?: string;
    url: string;
  }[];
}

const AppMenuDrop = ({ menuList }: IMenuProps) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={menuRef} className="app-menu-drop">
      <div onClick={() => setOpen(!open)} className="app-menu-drop-trigger">
        <AppIcon icon="ic:round-menu" width={30} />
      </div>
      <ul className={`app-menu-drop-list ${open ? "block" : "hidden"}`}>
        {menuList.map((item, index) => (
          <li
            key={index}
            className="app-menu-drop-item"
            onClick={() => {
              setOpen(!open);
              // router.push(item.url);
            }}
          >
            {item.icon && <AppIcon icon={item.icon} width={20} />}
            <span>{item.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AppMenuDrop;
